import { render, staticRenderFns } from "./PageAccueil.vue?vue&type=template&id=0a809124&scoped=true"
import script from "./PageAccueil.vue?vue&type=script&lang=js"
export * from "./PageAccueil.vue?vue&type=script&lang=js"
import style0 from "./PageAccueil.vue?vue&type=style&index=0&id=0a809124&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a809124",
  null
  
)

export default component.exports